import React from 'react'
import { CFooter } from '@coreui/react'

const TheFooter = () => {
  return (
    <CFooter fixed={true}>
      <div className="row">
        <div className="col-md-6">
            <a href="#" target="_blank" rel="noopener noreferrer"></a>
            <span className="ml-1">&copy; 2021 Finsights GSTIN.</span>
        </div>
       
      <div className="col-md-6 text-right mobile-text-left">
        <span className="mr-1">Powered by</span>
        <a href="/" className="text-primary"  rel="noopener noreferrer">Finsights</a>
      </div>
    </div>
    </CFooter>
  )
}

export default React.memo(TheFooter)
